import React from 'react';
import { LOGO_DATA_URL } from '../assets/logo';

/**
 * Easy1Basket brand logo (image). `size` is the rendered height in pixels.
 * The image is square (1:1) so width follows automatically.
 * Both variants render the same image now — the artwork carries its own
 * colors, so the light/dark distinction is no longer needed but kept for
 * backward compatibility with existing call sites.
 */
export function LogoImg({ size = 40, style }) {
  return (
    <img
      src={LOGO_DATA_URL}
      alt="Easy1Basket"
      style={{ height: size, width: 'auto', display: 'block', ...style }}
    />
  );
}

/** Text wordmark (white "Easy") used on dark/navy backgrounds, e.g. sidebar */
export function LogoLight({ size = 14 }) {
  return (
    <span style={{ fontSize: size, fontWeight: 800 }}>
      <span style={{ color: '#fff' }}>Easy</span>
      <span style={{ color: '#43A047' }}>1</span>
      <span style={{ color: '#F57C00' }}>Basket</span>
    </span>
  );
}

export function LogoDark({ size = 40 }) {
  return <LogoImg size={size} />;
}
